import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import { BrowserRouter } from "react-router-dom";
import RecoilNexus from "recoil-nexus";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <RecoilRoot>
    <RecoilNexus />
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
  </RecoilRoot>
);

reportWebVitals();